import React, { PropTypes } from 'react';
import axios from 'axios';
import Search from './components/Search';
import Results from './components/Results';
import Dashboard from './components/Dashboard';
import Pagination from './../estimations/modals/components/Pagination/Pagination';
import { loader } from './../layout/loader';
import { setEmptyActivityFeed, setEmptyActivityFeedSearch } from './../components/datatables-helpers';

class Root extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.state = {
            currentPage: 1,
            results: this.props.results,
            pages: this.props.results.totalRows / 10 + 1,
            currentSearch: Routing.generate('app_activity.get', {"q" : null, "type": 0}),
        };
    }

    componentDidMount() {

        setEmptyActivityFeed();

    }

    componentDidUpdate() {

        setEmptyActivityFeedSearch();

    }

    fetchData(payload) {

        console.log('fetchData:' + payload);

        loader.show();
        axios({
            method: 'get',
            url: payload,
            responseType: 'json',
        })
            .then((response) => {
                console.log(response.data);
                this.setState({
                    results: response.data,
                    pages: response.data.totalRows / 10 + 1,
                    currentPage: 1,
                    currentSearch: payload
                });
                loader.hide();
            })
            .catch((response) => {
                console.log(response);
            });
    }

    handlePageChange(i) {

        loader.show();
        axios({
            method: 'get',
            url: this.state.currentSearch + '&length=10&start=' + (i - 1) * 10,
            responseType: 'json',
        })
            .then((response) => {
                console.log(response.data);
                this.setState({
                    results: response.data,
                    currentPage: i
                });
                loader.hide();
            })
            .catch((response) => {
                console.log(response);
            });

    }

    render() {
        if (this.props.template == 'dashboard') {
            return (
                <div>
                    <Dashboard results={this.state.results} />
                </div>
            )
        } else {
            return (
                <div>
                    <Search fetchData={this.fetchData} />
                    <Results results={this.state.results} />
                    <Pagination onChange={this.handlePageChange} pages={this.state.pages} activePage={this.state.currentPage} />
                </div>
            );
        }
    }

}

export default Root;




// WEBPACK FOOTER //
// ./src/_app/activity-feed/_Root.jsx